import {Section} from "../../@types/singlePaymentMethodDescriptionSectionResources.tsx";

export const PisDescriptionSectionConfig: Section = {
    heading: 'what_is_pis_heading',
    description: 'what_is_pis_description',
    paragraphs: [
        {
            heading: 'how_pis_works_heading',
            orderedList: [
                'how_pis_works_list_1',
                'how_pis_works_list_2',
                'how_pis_works_list_3',
                'how_pis_works_list_4',
                'how_pis_works_list_5',
            ]
        },
        {
            heading: 'features_heading',
            unorderedList: [
                'pis_features_list_1',
                'pis_features_list_2',
                'pis_features_list_3',
                'pis_features_list_4',
                'pis_features_list_5',
                'pis_features_list_6',
            ],
            description: 'pis_features_description'
        }
    ]
}
